const drawerDetails = () => document.getElementById('Details-menu-drawer-container');

const cleanupScrollLock = () => {
  const hasOpenDrawer = document.querySelector('#Details-menu-drawer-container[open], dialog[open][scroll-lock]');
  if (hasOpenDrawer) return;
  document.documentElement.classList.remove('hanfi-menu-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('position');
  document.documentElement.style.removeProperty('overflow');
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-hanfi-menu-trigger]');
  if (!trigger) return;

  event.preventDefault();
  const hanfiMenuTrigger = document.querySelector('[data-hanfi-menu-open]');
  if (hanfiMenuTrigger instanceof HTMLElement) {
    hanfiMenuTrigger.click();
    return;
  }

  const details = drawerDetails();
  const menuTrigger = details?.querySelector(':scope > summary') || document.querySelector('.header-drawer--mobile summary');

  if (menuTrigger instanceof HTMLElement) {
    menuTrigger.click();
  } else if (details instanceof HTMLDetailsElement) {
    details.open = true;
    details.classList.add('menu-open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('toggle', (event) => {
  if (event.target !== drawerDetails()) return;
  const details = event.target;
  document.documentElement.classList.toggle('hanfi-menu-open', details.open);
  if (!details.open) window.setTimeout(cleanupScrollLock, 80);
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') window.setTimeout(cleanupScrollLock, 80);
});

window.addEventListener('pageshow', cleanupScrollLock);

const mountBottomNav = (bottomNav) => {
  if (!(bottomNav instanceof HTMLElement) || bottomNav.dataset.hanfiBottomNavReady === 'true') return;
  const isProductPage =
    bottomNav.dataset.template === 'product' ||
    document.querySelector('main[data-template^="product"]') ||
    document.body.classList.contains('template-product');
  if (bottomNav.dataset.hideOnProduct === 'true' && isProductPage) {
    bottomNav.remove();
    return;
  }
  bottomNav.dataset.hanfiBottomNavReady = 'true';

  const moveToViewportLayer = () => {
    if (bottomNav.parentElement === document.body) return;
    document.body.appendChild(bottomNav);
    bottomNav.style.position = 'fixed';
    bottomNav.style.left = '0';
    bottomNav.style.right = '0';
    bottomNav.style.bottom = '0';
    bottomNav.style.top = 'auto';
  };

  moveToViewportLayer();
  window.requestAnimationFrame(moveToViewportLayer);

  const scrollRoot = document.querySelector('.page-wrapper');
  const readScrollY = () => {
    const rootScroll = scrollRoot instanceof HTMLElement ? scrollRoot.scrollTop : 0;
    return Math.max(rootScroll || window.scrollY || document.documentElement.scrollTop || 0, 0);
  };

  let lastScrollY = readScrollY();
  let ticking = false;

  const minDelta = 5;

  let headerHeight = 0;
  const updateHeaderHeight = () => {
    const value = window.getComputedStyle(document.body).getPropertyValue('--header-height');
    headerHeight = Number.parseFloat(value) || 0;
  };
  updateHeaderHeight();

  const updateNav = () => {
    ticking = false;

    const scrollY = readScrollY();
    const delta = scrollY - lastScrollY;

    if (Math.abs(delta) < minDelta) return;

    if (scrollY <= headerHeight) {
      bottomNav.classList.remove('is-hidden');
    } else if (delta > 0) {
      bottomNav.classList.remove('is-hidden');
    } else {
      bottomNav.classList.add('is-hidden');
    }

    lastScrollY = scrollY;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateNav);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  if (scrollRoot instanceof HTMLElement) {
    scrollRoot.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
};

document.querySelectorAll('[data-hanfi-bottom-nav]').forEach(mountBottomNav);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-hanfi-bottom-nav]').forEach(mountBottomNav);
});
